<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">
            {{ client ? client.name : 'Client' }}
          </h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton
              tag="router-link"
              :to="{
                name: 'accounts.accountId.clients.clientUuid.edit',
                params: {
                  ...$route.params,
                },
              }"
              primary
              class="ml-auto md:ml-4"
            >
              Edit
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <nav class="border-b-2 border-gray-400">
          <RouterLink
            :to="{
              name: 'accounts.accountId.clients.clientUuid',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Details
          </RouterLink>
          <RouterLink
            :to="{
              name: 'accounts.accountId.clients.clientUuid.movements',
              params: {
                ...$route.params,
              },
            }"
            class="font-medium py-3 border-b-2 border-gray-400 text-gray-500 inline-block ml-4 -mb-2px hover:border-gray-700 hover:text-gray-700"
            exact-active-class="border-blue-700 text-gray-900"
          >
            Movements
          </RouterLink>
        </nav>
        <div class="mt-12">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import { middleware } from '@/routes/guards';

export default {
  beforeRouteEnter(to, from, next) {
    const check = middleware('account-permission:read clients');

    check(to, from, async (args) => {
      if (typeof args !== 'undefined') {
        return next(...args);
      }

      const { clientUuid: accountClientUuid } = to.params;

      try {
        await store.dispatch('ui/accountClients/read', { accountClientUuid });
        return next();
      } catch (error) {
        return next(false);
      }
    });
  },

  computed: {
    ...mapGetters('ui/accountClients', ['client']),
  },
};
</script>
